import Components from './RelatedApproval.vue';

const relatedApproval = {
    install:function(Vue) {
        Vue.component('relatedApproval', Components)
    }
}

export default relatedApproval;